import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import Footerr from "../../components/Footerr";
import NavBar from "../../components/Navbarr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getCategoriesNum } from "../../services/get-categories-num";
import { getByPagination } from "../../services/get-by-search";
import { getBySearch } from "../../services/get-search-product";
import { UserContext } from "../../components/context/userContext";
import { filterSearchProducts } from "../../services/post-filter";
import Lottie from "react-lottie";
import {
  defaultOptionsEmpty,
  defaultOptionsLoading,
} from "../../assets/lottie-animations/animationOptions";
import ProductList from "../../components/ProductList";
import { Helmet } from "react-helmet-async";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function ShopScreen() {
  // You would replace these with dynamic state or props
  const { searchQuery, setSearchQuery } = useContext(UserContext);
  const { height, width } = useWindowDimensions();
  const [price, setPrice] = useState<any>(1000); // Example starting price
  const [weight, setWeight] = useState<any>(0); // Example starting price

  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(12);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [listProducts, setListProducts] = useState<any>([]);
  const [listCategoriesNum, setListCategoriesNum] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [applyFilter, setApplayFilter] = useState(false);
  const [displayFilters, setDisplayFilters] = useState(false);
  const [clickedButton, setClickedButton] = useState<null | "apply" | "reset">(
    null,
  );
  const { networkError, setNetworkError } = useContext(UserContext);

  const [battery, setBattery] = useState<any>(100); // default 100%

  const handleCheckboxChange = (subCategoryId) => {
    // Check if the subCategoryId is already in the array
    if (selectedSubCategories.includes(subCategoryId)) {
      // If present, remove it
      setSelectedSubCategories((prev) =>
        prev.filter((id) => id !== subCategoryId),
      );
    } else {
      // If not present, add it
      setSelectedSubCategories((prev) => [...prev, subCategoryId]);
    }
  };
  const doGetCategoriesNum = () => {
    setLoading(true);
    getCategoriesNum()
      .then((response) => {
        setLoading(false);
        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setListCategoriesNum(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const doGetProductsByPagination = (page: any, limit: any) => {
    setLoading(true);
    getByPagination(page, limit)
      .then((response) => {
        setLoading(false);

        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response?.success) {
          setListProducts([...listProducts, ...response.content.products]);
          setTotalPages(response.content.totalPages);
          setCurrentPage(response.content.currentPage);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const doGetInitialeListProducts = (page: any, limit: any) => {
    setLoading(true);
    getByPagination(page, limit)
      .then((response) => {
        setLoading(false);

        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response?.success) {
          setListProducts(response.content.products);
          setTotalPages(response.content.totalPages);
          setCurrentPage(response.content.currentPage);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const loadMoreAction = () => {
    let newPage = page + 1;
    setPage(newPage);
    doGetProductsByPagination(newPage, 6);
  };

  const doGetSearchedProducts = () => {
    if (!Boolean(searchQuery)) {
      return;
    } else {
      setLoading(true);
      getBySearch(searchQuery)
        .then((response) => {
          setLoading(false);

          if (response.status === 500) {
            toast.error("internal server error");
            return;
          }
          if (!response.success) {
            toast.error(response.message);
            return;
          }
          if (response.success) {
            setListProducts(response.content.products);
          }
        })
        .catch((error) => {
          setLoading(false);

          toast.error(error);
        });
    }
  };

  const doResetFilter = () => {
    if (!applyFilter) {
      return;
    }
    setApplayFilter(false);
    setLimit(12);
    setPage(1);
    doGetInitialeListProducts(1, 12);
    setSelectedSubCategories([]);
  };

  const doApplayFilter = () => {
    const data = {
      sortBy: "price",
      order: "asc",
      limit: 10,
      skip: 0,
      filters: {
        subCategory: selectedSubCategories,
        price: [0, Number(price)],
        weight: weight === 0 ? [] : [Number(weight), Number(weight)],
      },
    };

    setLoading(true);

    filterSearchProducts(data)
      .then((response) => {
        setLoading(false);
        setApplayFilter(true);

        if (response.status === 500) {
          toast.error("internal server error");
          return;
        }
        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response.success) {
          setListProducts(response.content);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!Boolean(searchQuery)) {
      setLimit(12);
      setPage(1);
      doGetInitialeListProducts(1, 12);
    } else {
      doGetSearchedProducts();
    }
  }, [searchQuery]);

  useEffect(() => {
    doGetCategoriesNum();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Accessoires téléphone en Tunisie | Coques, chargeurs | Mhiri Store
        </title>
        <meta
          name="description"
          content="Tous les accessoires pour téléphone en Tunisie : coques, chargeurs rapides, câbles, protections écran."
        />
      </Helmet>


      <div>
        <div>
          <NavBar page={"shop"} />
          <h1 style={{ display: "none" }}>
            Smartphones et accessoires en Tunisie – Mhiri Store
          </h1>
        </div>
        <div className="shop-container">
          {width <= 768 ? (
            <>
              {displayFilters ? (
                <aside className="filter-sidebar">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <span style={{ fontSize: 20, fontWeight: 600 }}>
                      Filtres
                    </span>
                    <i
                      className="bx bx-chevron-up"
                      style={{ fontSize: 22 }}
                      onClick={() => setDisplayFilters(false)}
                    ></i>
                  </div>
                  <div>
                    <h3>Categories</h3>
                    <ul>
                      {listCategoriesNum?.length > 0 ? (
                        listCategoriesNum.map((category, index) => (
                          <li key={index}>
                            <p style={{ fontWeight: 700, fontSize: 22 }}>
                              {category.categoryName}
                            </p>
                            {category.subCategories.map((subCat, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  marginLeft: 20,
                                  alignItems: "center",
                                  alignContent: "center",
                                  width: "70%",
                                }}
                              >
                                <span style={{ fontSize: 18 }}>
                                  {subCat?.subCategoryName}
                                </span>
                                <input
                                  type="checkbox"
                                  style={{
                                    borderRadius: 10,
                                    backgroundColor: "#fff",
                                    marginLeft: 10,
                                  }}
                                  onChange={() =>
                                    handleCheckboxChange(subCat?.subCategoryId)
                                  }
                                  checked={selectedSubCategories.includes(
                                    subCat?.subCategoryId,
                                  )}
                                />
                              </div>
                            ))}
                          </li>
                        ))
                      ) : (
                        <></>
                      )}
                    </ul>
                  </div>
                  <div>
                    <label
                      htmlFor="storageRange"
                      style={{ fontWeight: "bold", marginBottom: 8 }}
                    >
                      Prix {price} DT
                    </label>
                    {/* Implement a price range slider or similar component */}
                    <input
                      type="range"
                      min="0"
                      max="5000"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      className="price-slider-phone"
                      title={price}
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        fontWeight: 700,
                        marginTop: 15,
                        marginBottom: 15,
                      }}
                    >
                      Capacité de stockage :{" "}
                      {weight === 0 ? "All" : `${weight} Go`}
                    </label>

                    <div
                      style={{
                        marginTop: 10,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                      }}
                    >
                      {[0, 64, 128, 256, 512, 1024, 2048].map((val) => (
                        <label
                          key={val}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            cursor: "pointer",
                            fontSize: 16,
                          }}
                        >
                          <input
                            type="radio"
                            name="storage"
                            value={val}
                            checked={weight === val}
                            onChange={() => setWeight(val)}
                          />
                          {val === 0 ? "All stockage" : `${val} Go`}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div style={{ marginTop: 15 }}>
                    <label
                      htmlFor="batteryRange"
                      style={{ fontWeight: "bold", marginBottom: 8 }}
                    >
                      État de la batterie : {battery}%
                    </label>
                    <input
                      id="batteryRange"
                      type="range"
                      min="0"
                      max="100"
                      step="1"
                      value={battery}
                      onChange={(e) => setBattery(e.target.value)}
                      className="battery-slider"
                    />
                  </div>
                  <div>
                    <h3>Evaluation</h3>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: 40,
                        justifyContent: "space-evenly",
                      }}
                    >
                      <i
                        className="bx bx-star"
                        style={{ fontSize: 42, color: "#EFBE07" }}
                      ></i>
                      <i
                        className="bx bx-star"
                        style={{ fontSize: 42, color: "#EFBE07" }}
                      ></i>
                      <i
                        className="bx bx-star"
                        style={{ fontSize: 42, color: "#EFBE07" }}
                      ></i>
                      <i
                        className="bx bx-star"
                        style={{ fontSize: 42, color: "#EFBE07" }}
                      ></i>
                    </div>
                  </div>
                  <div
                    className="btn-filter-container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 12,
                      marginTop: 10,
                    }}
                  >
                    <button
                      style={{
                        padding: "14px 24px",
                        fontSize: 15,
                        fontWeight: clickedButton === "apply" ? 600 : 500,
                        borderRadius: 8,
                        backgroundColor: "#fff",
                        color: clickedButton === "apply" ? "#159b7b" : "#333",
                        border:
                          clickedButton === "apply"
                            ? "2px solid #159b7b"
                            : "2px solid transparent",
                        cursor:
                          loading || applyFilter ? "not-allowed" : "pointer",
                        opacity: loading || applyFilter ? 0.5 : 1,
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        doApplayFilter();
                        setDisplayFilters(false);
                        setClickedButton("apply");
                      }}
                      disabled={loading || applyFilter}
                    >
                      {loading ? "Appliquer..." : "Appliquer Filtre"}
                    </button>

                    <button
                      style={{
                        padding: "14px 24px",
                        fontSize: 15,
                        fontWeight: clickedButton === "reset" ? 600 : 500,
                        borderRadius: 8,
                        backgroundColor: "#fff",
                        color: clickedButton === "reset" ? "#159b7b" : "#333",
                        border:
                          clickedButton === "reset"
                            ? "2px solid #159b7b"
                            : "2px solid transparent",
                        cursor: !applyFilter ? "not-allowed" : "pointer",
                        opacity: !applyFilter ? 0.5 : 1,
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        doResetFilter();
                        setDisplayFilters(false);
                        setClickedButton("reset");
                      }}
                      disabled={!applyFilter}
                    >
                      Reset Filtre
                    </button>
                  </div>
                </aside>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span style={{ fontSize: 24, fontWeight: 600 }}>Filtres</span>
                  <i
                    style={{ fontSize: 22 }}
                    className="bx bx-chevron-down"
                    onClick={() => setDisplayFilters(true)}
                  ></i>
                </div>
              )}
            </>
          ) : (
            <aside className="filter-sidebar">
              <h2>Filtre par</h2>
              <div>
                <h3>Catégories</h3>
                <ul>
                  {listCategoriesNum?.length > 0 ? (
                    listCategoriesNum.map((category, index) => (
                      <li key={index}>
                        <p style={{ fontWeight: 700, fontSize: 22 }}>
                          {category.categoryName}
                        </p>
                        {category.subCategories.map((subCat, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: 20,
                              justifyContent: "space-between",
                              alignItems: "center",
                              alignContent: "center",
                              width: "70%",
                            }}
                          >
                            <p style={{ fontSize: 18 }}>
                              {subCat?.subCategoryName}
                            </p>
                            <input
                              type="checkbox"
                              style={{
                                borderRadius: 10,
                                backgroundColor: "#fff",
                                marginLeft: 10,
                              }}
                              onChange={() =>
                                handleCheckboxChange(subCat?.subCategoryId)
                              }
                              checked={selectedSubCategories.includes(
                                subCat?.subCategoryId,
                              )}
                            />
                          </div>
                        ))}
                      </li>
                    ))
                  ) : (
                    <></>
                  )}
                </ul>
              </div>
              <div>
                <h3>Prix {price} DT</h3>
                {/* Implement a price range slider or similar component */}
                <input
                  type="range"
                  min="0"
                  max="5000"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  className="price-slider"
                  title={price}
                />
              </div>
              <div style={{ marginTop: 15, marginBottom: 15 }}>
                <label style={{ fontWeight: 700 }}>
                  Capacité de stockage : {weight === 0 ? "All" : `${weight} Go`}
                </label>

                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  {[0, 64, 128, 256, 512, 1024, 2048].map((val) => (
                    <label
                      key={val}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        cursor: "pointer",
                        fontSize: 16,
                      }}
                    >
                      <input
                        type="radio"
                        name="storage"
                        value={val}
                        checked={weight === val}
                        onChange={() => setWeight(val)}
                      />
                      {val === 0 ? "All stockage" : `${val} Go`}
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <h3>Rating</h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: 40,
                    justifyContent: "space-evenly",
                  }}
                >
                  <i
                    className="bx bx-star"
                    style={{ fontSize: 36, color: "#EFBE07" }}
                  ></i>
                  <i
                    className="bx bx-star"
                    style={{ fontSize: 36, color: "#EFBE07" }}
                  ></i>
                  <i
                    className="bx bx-star"
                    style={{ fontSize: 36, color: "#EFBE07" }}
                  ></i>
                  <i
                    className="bx bx-star"
                    style={{ fontSize: 36, color: "#EFBE07" }}
                  ></i>
                </div>
              </div>
              <div
                className="btn-filter-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 12,
                  marginTop: 10,
                }}
              >
                <button
                  style={{
                    padding: "14px 24px",
                    fontSize: 15,
                    fontWeight: clickedButton === "apply" ? 600 : 500,
                    borderRadius: 8,
                    backgroundColor: "#fff",
                    color: clickedButton === "apply" ? "#159b7b" : "#333",
                    border:
                      clickedButton === "apply"
                        ? "2px solid #159b7b"
                        : "2px solid transparent",
                    cursor: loading || applyFilter ? "not-allowed" : "pointer",
                    opacity: loading || applyFilter ? 0.5 : 1,
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    doApplayFilter();
                    setDisplayFilters(false);
                    setClickedButton("apply");
                  }}
                  disabled={loading || applyFilter}
                >
                  {loading ? "appliquer..." : "Appliquer Filtre"}
                </button>

                <button
                  style={{
                    padding: "14px 24px",
                    fontSize: 15,
                    fontWeight: clickedButton === "reset" ? 600 : 500,
                    borderRadius: 8,
                    backgroundColor: "#fff",
                    color: clickedButton === "reset" ? "#159b7b" : "#333",
                    border:
                      clickedButton === "reset"
                        ? "2px solid #159b7b"
                        : "2px solid transparent",
                    cursor: !applyFilter ? "not-allowed" : "pointer",
                    opacity: !applyFilter ? 0.5 : 1,
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    doResetFilter();
                    setDisplayFilters(false);
                    setClickedButton("reset");
                  }}
                  disabled={!applyFilter}
                >
                  Reset Filtre
                </button>
              </div>
            </aside>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: width <= 768 ? "100%" : "75%",
              minHeight: "80vh",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <div className="title-container">
              <h2>Produits</h2>
            </div>
            {!loading ? (
              <main className="product-list-shop">
                <ProductList listProducts={listProducts} type={"product"} />
              </main>
            ) : (
              <div style={{ height: "100%", width: "100%", minHeight: "70vh" }}>
                <Lottie
                  options={defaultOptionsLoading}
                  height={150}
                  width={150}
                />
              </div>
            )}
            {totalPages == currentPage ||
            applyFilter ||
            searchQuery ||
            listProducts?.length <= 0 ? (
              <></>
            ) : (
              <button
                onClick={() => loadMoreAction()}
                style={{
                  borderRadius: 10,
                  backgroundColor: "#DF7B11",
                  padding: 10,
                  alignSelf: "center",
                  borderWidth: 0,
                  color: "#fff",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                Voir plus{" "}
                <i className="bx bx-sync" style={{ fontSize: 24 }}></i>
              </button>
            )}
          </div>
        </div>
        <div>
          <Footerr />
        </div>
      </div>
    </>
  );
}

export default ShopScreen;
